// Small fixed-corner badge showing whether the LEGACY or NEW (V4) app is currently loaded,
// so it's obvious at a glance which UI/API you're on. Driven by the shared entrypoint's own
// app-selection decision (not the URL, which is ambiguous under the REACT_APP_NEW_AT_N toggle).
//
// Shown when NODE_ENV !== 'production' (local `npm start`) OR REACT_APP_SHOW_APP_BADGE === 'true'
// (set in .env.dev / .env.beta). Hidden in the production build (.env sets it to false).
export function mountDevBadge(kind: 'new' | 'legacy', base: string): void {
  const enabled =
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_SHOW_APP_BADGE === 'true';
  if (!enabled) return;

  const isNew = kind === 'new';
  const api = isNew
    ? process.env.REACT_APP_API_V4 || '(unset → relative URLs)'
    : process.env.REACT_APP_API || '';

  const render = () => {
    if (document.getElementById('__app_env_badge__')) return;
    const el = document.createElement('div');
    el.id = '__app_env_badge__';
    el.textContent = isNew ? 'NEW · V4' : 'LEGACY';
    el.title =
      `${isNew ? 'New app (API V4)' : 'Legacy app'}  •  path base "${base || '/'}"  •  ${process.env.NODE_ENV}` +
      `\nAPI: ${api}`;
    const styles: Partial<CSSStyleDeclaration> = {
      position: 'fixed',
      bottom: '8px',
      right: '8px',
      zIndex: '2147483647',
      padding: '3px 8px',
      borderRadius: '6px',
      font: '600 11px/1.4 system-ui, -apple-system, sans-serif',
      color: '#ffffff',
      background: isNew ? '#2563eb' : '#6b7280',
      boxShadow: '0 1px 3px rgba(0,0,0,.35)',
      pointerEvents: 'none',
      userSelect: 'none',
      letterSpacing: '.3px',
    };
    Object.assign(el.style, styles);
    document.body.appendChild(el);
  };

  if (document.body) render();
  else window.addEventListener('DOMContentLoaded', render, { once: true });
}
